import React, { useState } from 'react';
import {
  Container,
  Typography,
  Box,
  Button,
  Card,
  CardContent,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Alert,
  CircularProgress
} from '@mui/material';
import { Check } from '@mui/icons-material';
import { useNavigate } from 'react-router-dom';
import api from '../../services/authService';

const Upgrade = () => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const navigate = useNavigate();

  const handleUpgrade = async () => {
    setLoading(true);
    setError('');

    try {
      const response = await api.post('/payment/create-checkout-session');
      
      if (response.data.url) {
        // Redirect to Stripe Checkout
        window.location.href = response.data.url;
      }
    } catch (err) {
      setError(err.response?.data?.error || 'Failed to initiate checkout. Please try again.');
      setLoading(false);
    }
  };

  return (
    <Container component="main" maxWidth="md">
      <Box
        sx={{
          marginTop: 4,
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
        }}
      >
        <Typography component="h1" variant="h3" align="center" gutterBottom>
          Upgrade to Full Access
        </Typography>
        
        <Typography variant="h6" align="center" color="textSecondary" paragraph>
          Continue enjoying unlimited transcription features
        </Typography>

        {error && (
          <Alert severity="error" sx={{ mb: 3, width: '100%' }}>
            {error}
          </Alert>
        )}

        <Card sx={{ mt: 3, width: '100%', maxWidth: 600 }}>
          <CardContent sx={{ p: 4 }}>
            <Box sx={{ textAlign: 'center', mb: 3 }}>
              <Typography variant="h4" component="div" gutterBottom>
                $10
                <Typography variant="h6" component="span" color="textSecondary">
                  /month
                </Typography>
              </Typography>
              <Typography variant="body2" color="textSecondary">
                Simple, transparent pricing
              </Typography>
            </Box>

            <List>
              <ListItem>
                <ListItemIcon>
                  <Check color="primary" />
                </ListItemIcon>
                <ListItemText primary="Unlimited transcription minutes" />
              </ListItem>
              <ListItem>
                <ListItemIcon>
                  <Check color="primary" />
                </ListItemIcon>
                <ListItemText primary="Create and manage organizations" />
              </ListItem>
              <ListItem>
                <ListItemIcon>
                  <Check color="primary" />
                </ListItemIcon>
                <ListItemText primary="Team collaboration features" />
              </ListItem>
              <ListItem>
                <ListItemIcon>
                  <Check color="primary" />
                </ListItemIcon>
                <ListItemText primary="Calendar integration" />
              </ListItem>
              <ListItem>
                <ListItemIcon>
                  <Check color="primary" />
                </ListItemIcon>
                <ListItemText primary="Email notifications" />
              </ListItem>
              <ListItem>
                <ListItemIcon>
                  <Check color="primary" />
                </ListItemIcon>
                <ListItemText primary="Priority support" />
              </ListItem>
              <ListItem>
                <ListItemIcon>
                  <Check color="primary" />
                </ListItemIcon>
                <ListItemText primary="Cancel anytime" />
              </ListItem>
            </List>

            <Box sx={{ mt: 4, display: 'flex', flexDirection: 'column', gap: 2 }}>
              <Button
                variant="contained"
                size="large"
                onClick={handleUpgrade}
                disabled={loading}
                fullWidth
              >
                {loading ? <CircularProgress size={24} /> : 'Upgrade Now'}
              </Button>
              <Button
                variant="outlined"
                size="large"
                onClick={() => navigate('/dashboard')}
                fullWidth
              >
                Maybe Later
              </Button>
            </Box>

            <Typography variant="caption" color="textSecondary" align="center" display="block" sx={{ mt: 2 }}>
              Secure payment powered by Stripe. Cancel anytime.
            </Typography>
          </CardContent>
        </Card>
      </Box>
    </Container>
  );
};

export default Upgrade;
